export default function DS_What_Is_Data() {
  return <div>DS_What_Is_Data Component</div>;
}
